<button
  [class]="'lt-button lt-button--' + variant() + ' lt-button--' + size()"
  [type]="type()"
  [disabled]="disabled() || loading()"
  [attr.data-testid]="testId()"
  [attr.tabindex]="tabIndex()"
>
  @if (loading()) {
    <img class="u-spin" [src]="loaderIcon" width="20" alt="Loading" />
  }
  <ng-content></ng-content>
</button>
